import Client from './client';

export default class Partners extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/internal/partners`, {
      ...options,
       method: 'POST',
    });
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/partners/${id}`, options);
  }

  deleteById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/partners/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
